import Splide from '@splidejs/splide';

const SELECTORS = {
    block: '.wp-block-ssm-testimonials',
    carousel: '.splide',
};

const DEFAULT_OPTIONS = {
    perPage: 3,
    perMove: 1,
    arrows: true,
    pagination: false,
    gap: '1.5rem',
    breakpoints: {
        1023: {
            perPage: 2,
        },
        640: {
            perPage: 1,
        },
    },
};

export function initTestimonials(block, isEditor = false) {
    const carousel = block.querySelector(SELECTORS.carousel);

    // Skip if already initialized
    if (!carousel || carousel.splide) {
        return null;
    }

    try {
        const hasArrows = carousel.querySelector('.splide__arrows') !== null;

        const options = {
            ...DEFAULT_OPTIONS,
            arrows: hasArrows,
            ...(isEditor && { drag: false })
        };

        const splide = new Splide(carousel, options);

        splide.on('overflow', function (isOverflow) {
            if (isOverflow) {
                splide.Components.Elements.list.classList.remove('justify-center');
            } else {
                splide.Components.Elements.list.classList.add('justify-center');
            }
        });

        splide.mount();

        return {
            destroy() {
                if (splide && typeof splide.destroy === 'function') {
                    splide.destroy();
                }
                delete carousel.splide;
            },
        };
    } catch (error) {
        console.error('Error initializing Testimonials carousel:', error, carousel);

        return null;
    }
}

export function Testimonials() {
    document.querySelectorAll(SELECTORS.block).forEach((block) => {
        initTestimonials(block);
    });
}
